module.exports = {"pt-BR":{"components":{"cpfCnpjField":{"label":"CPF/CNPJ","placeholder":"Informe o CPF ou CNPJ"}}}}